// Matches a pay command in free-form post content. Requires either a `$` prefix
// on the amount OR a `USDC` suffix (or both) so bare numbers like "@alice 5"
// don't accidentally trigger a transfer.
const PAY_COMMAND_REGEX =
	/(?:(?:pay|send)\s+)?@([a-z0-9_]{3,20})\s+(?:\$(\d+(?:\.\d{1,2})?)(?:\s+USDC\b)?|(\d+(?:\.\d{1,2})?)\s+USDC\b)/i

export function parsePayCommand(content: string): { handle: string; amountUsd: number } | null {
	const match = PAY_COMMAND_REGEX.exec(content)
	if (!match) {
		return null
	}
	const handle = match[1].toLowerCase()
	const amountUsd = Number.parseFloat(match[2] ?? match[3])
	if (amountUsd < 1 || !Number.isFinite(amountUsd)) {
		return null
	}
	return { handle, amountUsd }
}
